export const formPaths = {
    // macro sezioni
    altreNotizie: 'my_SezioneI__Rilevazione.my_AltreNotizie',
    ammControllo: 'my_SezioneI__Rilevazione.my_AmministrazioneControllo',
    baseSociale: 'my_SezioneI__Rilevazione.my_EffettivitaBaseSociale',
    bilancio: 'my_SezioneI__Rilevazione.my_Bilancio',
    conclusioni: 'my_SezioneI__Rilevazione.my_Conclusioni',
    contributoBiennale: 'my_SezioneI__Rilevazione.my_ContributoBiennale',
    contributoLegge59: 'my_SezioneI__Rilevazione.my_ContributoLegge59',
    datiBilancio: 'my_SezioneI__Rilevazione.my_DatiBilancio',
    datiIdentificativi: 'my_SezioneI__Rilevazione.my_DatiIdentificativi',
    naturaMutualistica: 'my_SezioneI__Rilevazione.my_NaturaMutualistica',
    scopoSociale: 'my_SezioneI__Rilevazione.my_RaggScopoSociale',

    // schede di settore
    schedaAltreCoop: 'my_SezioneI__Rilevazione.my_SchedaCoopAltreCoop',
    schedaCoopAgricole: 'my_SezioneI__Rilevazione.my_SchedaCoopAgricole',
    schedaCoopConsumo: 'my_SezioneI__Rilevazione.my_SchedaCoopConsumo',
    schedaCoopDettaglianti: 'my_SezioneI__Rilevazione.my_SchedaCoopDettaglianti',
    schedaCoopEdil: 'my_SezioneI__Rilevazione.my_SchedaCoopEdil',
    schedaCoopFidi: 'my_SezioneI__Rilevazione.my_SchedaCoopFidi',
    schedaCoopPDL: 'my_SezioneI__Rilevazione.my_SchedaCoopPDL',
    schedaCoopPesca: 'my_SezioneI__Rilevazione.my_SchedaCoopPesca',
    schedaCoopSociali: 'my_SezioneI__Rilevazione.my_SchedaCoopSociali',
    schedaCoopTrasporto: 'my_SezioneI__Rilevazione.my_SchedaCoopTrasporto',
} as const;
